import React, { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { Form } from '@kuzmycz/react-form-ula';
import { Button, Label, Loader } from '../../../../Components/uielements';
import BioPlusTextField from '../../../../Components/form-fields/BioPlusTextField';
import DropDown from '../../../../Components/uielements/dropDown';
import {
  ErrorModalWrapper,
  ModalButtonWrapper,
  ModalWrapper,
  OutlineButton,
} from '../../../../services/settings/appStyle/global.style';
import {
  checkAblityToCreateMasterGeofence,
  premiseOfGeofences,
  saveMasterGeofence,
} from '../../../../services/bioplus-services/premise';
import { ModalGap, ContentWrapper } from '../premise.style';
import { IntlMessages } from '../../../../helper/langHelper';
import { LinksModalWrapper, LoaderWrapper } from '../../DashboardV2/dashboard.style';
import { EmptyState, ErrorSvg } from '../../../../Components/icons';

export const convertGeofencesToFormat = (geofences) => {
  return geofences?.map((geofence) => ({
    value: geofence?._id,
    label: geofence?.name,
  }));
};

const getLabelByValue = (geofences, id) => {
  const foundGeofence = geofences?.find((geofence) => geofence?.value === id);
  return foundGeofence ? foundGeofence.label : 'Master Geofence';
};

const AssignMasterGeofenceForPremise = ({ onClose, premise }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [selectedMasterGeofence, setSelectedMasterGeofence] = useState(premise?.masterGeofenceId);
  const [isError, setIsError] = useState(undefined);
  const queryClient = useQueryClient();

  const query = useQuery(['geofenceListOfPremise'], () => premiseOfGeofences(premise?._id));
  const geofencesBasedOnPremise = query?.data;

  const mutation = useMutation((premise) => saveMasterGeofence(premise), {
    onSuccess: async () => {
      await queryClient.invalidateQueries('premises');
      setIsProcessing(false);
      onClose();
    },
    onError: (error) => {
      setIsProcessing(false);
      alert(error);
      onClose();
    },
  });
  console.log(isError, 'isError');
  const handleSubmit = async () => {
    try {
      setIsProcessing(true);
      const response = await checkAblityToCreateMasterGeofence(selectedMasterGeofence);

      if (response && response?.status === 'Success') {
        const payload = {
          premiseId: premise?._id,
          geofenceId: selectedMasterGeofence,
        };
        mutation.mutate(payload);
      }
    } catch (error) {
      setIsError(error);
      setIsProcessing(false);
    }
  };

  const validator = (values) => undefined;

  const dropDownValue = convertGeofencesToFormat(geofencesBasedOnPremise);

  const handleSelectedValue = (value) => {
    if (value) {
      setSelectedMasterGeofence(value.value);
    }
  };

  if (isError) {
    return (
      <ErrorModalWrapper>
        <ErrorSvg style={{ width: '60px', height: '60px', justifySelf: 'center' }} />
        <Label align="center">
          <IntlMessages
            id="error.text.master.geofence"
            values={{ error: isError?.response?.data?.message }}
          />
        </Label>
        <ModalButtonWrapper>
          <OutlineButton onClick={onClose}>
            <IntlMessages id="modal.button.cancel" />
          </OutlineButton>
        </ModalButtonWrapper>
      </ErrorModalWrapper>
    );
  }

  return (
    <>
      <Form initialValues={{ ...premise }} validator={validator} onSubmit={handleSubmit}>
        {query?.isLoading ? (
          <ModalWrapper style={{ marginTop: '5px' }}>
            <LinksModalWrapper style={{ margin: '40px 0px' }}>
              <LoaderWrapper>
                <Loader />
              </LoaderWrapper>
            </LinksModalWrapper>
          </ModalWrapper>
        ) : (
          <>
            {geofencesBasedOnPremise && geofencesBasedOnPremise?.length > 0 ? (
              <ModalWrapper>
                <>
                  <ModalGap style={{ gap: '35px', marginBottom: '20px', marginTop: '5px' }}>
                    <BioPlusTextField
                      label={<IntlMessages id="nav.premises" />}
                      name="propertyName"
                      fullWidth
                      disabled
                    />

                    <DropDown
                      options={dropDownValue}
                      selectedOption={handleSelectedValue}
                      name="master_geofence"
                      placeholder="Master Geofence"
                      defaultValue={getLabelByValue(dropDownValue, selectedMasterGeofence)}
                      label="Master Geofence"
                    />
                  </ModalGap>
                  <ModalButtonWrapper>
                    <OutlineButton onClick={onClose}>
                      <IntlMessages id="modal.button.cancel" />
                    </OutlineButton>{' '}
                    {isProcessing ? (
                      <Button varient="normal" disabled={isProcessing}>
                        <div style={{ paddingRight: '10px' }}></div>
                        <IntlMessages id="button.text.processing" />
                        <Loader size="small" isNotRequiredLoadingText={true} />
                      </Button>
                    ) : (
                      <Button varient="normal" type="submit">
                        <IntlMessages id="modal.button.submit" />
                      </Button>
                    )}
                  </ModalButtonWrapper>
                </>
              </ModalWrapper>
            ) : (
              <ModalWrapper>
                <ContentWrapper>
                  <EmptyState />
                  <Label>
                    There is no geofence created for the premise "{premise?.propertyName}" yet.
                  </Label>
                </ContentWrapper>
                <ModalButtonWrapper>
                  <OutlineButton onClick={onClose}>
                    <IntlMessages id="modal.button.cancel" />
                  </OutlineButton>{' '}
                </ModalButtonWrapper>
              </ModalWrapper>
            )}
          </>
        )}
      </Form>
    </>
  );
};

export default AssignMasterGeofenceForPremise;
